import { OrdinaryObject } from 'src/modules/utils/shared/ordinary-object.model';

export class EnaioInboxProcessDto {

    id: string;
    inboxId: string;
    inboxTitle: string;
    columns: OrdinaryObject;

}
